/**
 * @flow
 * @relayHash 2aafa49478ff6380e68e860cdcd5e207
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdatePaymentSettingsInput = {|
  paymentTerm?: ?string,
  preferredCurrency?: ?string,
  paymentInfo?: ?string,
  includeVat?: ?boolean,
  vatPercentage?: ?number,
  taxPercentage?: ?number,
  taxIdentifier?: ?string,
  clientMutationId?: ?string,
|};
export type UpdatePaymentSettingsMutationVariables = {|
  input: UpdatePaymentSettingsInput
|};
export type UpdatePaymentSettingsMutationResponse = {|
  +updatePaymentSettings: ?{|
    +clientMutationId: ?string
  |}
|};
export type UpdatePaymentSettingsMutation = {|
  variables: UpdatePaymentSettingsMutationVariables,
  response: UpdatePaymentSettingsMutationResponse,
|};
*/

/*
mutation UpdatePaymentSettingsMutation(
  $input: UpdatePaymentSettingsInput!
) {
  updatePaymentSettings(input: $input) {
    clientMutationId
  }
}
*/

const node /*: ConcreteRequest*/ = (function () {
  var v0 = [
      {
        kind: 'LocalArgument',
        name: 'input',
        type: 'UpdatePaymentSettingsInput!',
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: 'LinkedField',
        alias: null,
        name: 'updatePaymentSettings',
        storageKey: null,
        args: [
          {
            kind: 'Variable',
            name: 'input',
            variableName: 'input'
          }
        ],
        concreteType: 'UpdatePaymentSettingsPayload',
        plural: false,
        selections: [
          {
            kind: 'ScalarField',
            alias: null,
            name: 'clientMutationId',
            args: null,
            storageKey: null
          }
        ]
      }
    ];
  return {
    kind: 'Request',
    fragment: {
      kind: 'Fragment',
      name: 'UpdatePaymentSettingsMutation',
      type: 'Mutation',
      metadata: null,
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    operation: {
      kind: 'Operation',
      name: 'UpdatePaymentSettingsMutation',
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    params: {
      operationKind: 'mutation',
      name: 'UpdatePaymentSettingsMutation',
      id: null,
      text:
        'mutation UpdatePaymentSettingsMutation(\n  $input: UpdatePaymentSettingsInput!\n) {\n  updatePaymentSettings(input: $input) {\n    clientMutationId\n  }\n}\n',
      metadata: {}
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = '07a87f9087f4d7d1843ff38adac3ddbf';
module.exports = node;
